module.exports = __webpack_public_path__ + "static/img/txz-logo.078998d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/txz-logo.png
// module id = Ugd/
// module chunks = 1